export default {
	SET_TOKEN: (state, payload) => {
		state.token = payload;
	},
	SET_TOKEN_EXPIRATION(state, payload) {
		state.tokenExpiration = payload;
		localStorage.setItem("blobTokenExpiration", JSON.stringify(payload));
	},
	REMOVE_TOKEN: (state) => {
		state.token = '';
	},
	REMOVE_TOKEN_EXPIRATION(state) {
		state.tokenExpiration = null;
		localStorage.removeItem("blobTokenExpiration");
	},
};
